import { lazy } from 'react';

export const MeasurementsList = lazy(() => import('./pages/MeasurementsList'));
export const CustomerScheduling = lazy(() => import('./pages/CustomerScheduling'));
export const ScheduleView = lazy(() => import('./pages/ScheduleView'));
export const FabricationMeasurement = lazy(() => import('./pages/FabricationMeasurement'));
export const FabricationSheet = lazy(() => import('./pages/FabricationSheet'));

export const MEASUREMENT_ROUTES = {
  list: '/staff/orders/:projectId/measurements',
  /** MC detail — since the 2026-08-27 merge this renders the fabrication
   *  capture page (`FabricationMeasurement`): visit header, scheduling &
   *  admin, per-opening capture, site photos. */
  detail: '/staff/orders/:projectId/measurements/:mcId',
  /** Global staff schedule view — defaults to "my schedule" for measurers. */
  schedule: '/staff/schedule',
  /** Public, no auth — customer-facing slot booking page. */
  customerScheduling: '/schedule/:token',
  /** DEPRECATED alias (2026-08-27 merge): redirects to `.detail`, which now
   *  renders the fabrication capture page. Do not link to this in new code. */
  fabrication: '/staff/orders/:projectId/measurements/:mcId/fabrication',
  /** Printable A4 fabrication sheet. */
  fabricationPrint: '/staff/orders/:projectId/measurements/:mcId/fabrication/print',
} as const;
